import { forwardRef } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { LinearProgress as BaseLinearProgress, LinearProgressProps } from '@lyearn/ui';
import { Maybe } from '@/types/schema';

type Props = LinearProgressProps & { ariaLabel?: Maybe<string> };

const LinearProgress = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { t } = useTranslation();
  const { ariaLabel: label, ...rest } = props;

  return (
    <BaseLinearProgress
      ref={ref}
      aria-label={label ? t('Common:ContentProgressBar', { label }) : t('Common:ProgressBar')}
      {...rest}
    />
  );
});

export default LinearProgress;
